/**
 * This component is used to display the power rankings for nationals.
 * WARNING Dummy data
 */
import React from "react";
import Ranking from "./RankingIndividual";

const PowerRankings = () => {
  // API request

  return (
    // Container for all pages
    <>
      <div className="flex flex-col items-start justify-center lg:justify-between mb-3">
        <div className="lg:block hidden flex flex-col items-start justify-start">
          <h2 className="text-lefttext-2xl font-bold mb-4 leading-tight">Power Rankings</h2>
        </div>

        <div className="flex flex-col items-start justify-start w-full">
          {/* content */}
          <Ranking
            img="oxford"
            number="1"
            team="Oxford Vikings"
            w="5"
            d="1"
            l="0"
            g="5"
            gd="+10"
            ppp="2.0"
            pk="1"
            desc="Oxford Vikings are Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam nec purus nec libero. Nullam nec purus nec libero. Nullam nec purus nec libero."
          />
          <Ranking
            img="sheffield"
            number="2"
            team="Sheffield Bears C"
            w="5"
            d="1"
            l="0"
            g="5"
            gd="+10"
            ppp="2.0"
            pk="1"
            desc="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean nec purus nec libero. Nullam nec purus nec libero. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tincidunt vitae lorem.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean nec purus nec libero. Nullam nec purus nec libero."
          />
          <Ranking
            img="southampton"
            number="3"
            team="Southampton Spitfires"
            w="5"
            l="0"
            d="1"
            g="5"
            gd="+10"
            ppp="2.0"
            pk="1"
          />
          <Ranking
            img="nottingham"
            number="4"
            team="Nottingham Mavericks C"
            w="5"
            l="0"
            d="1"
            g="5"
            gd="+10"
            ppp="2.0"
            pk="1"
          />
          <Ranking
            img="manchester"
            number="5"
            team="Manchester Metros"
            w="5"
            l="0"
            d="1"
            g="5"
            gd="+10"
            ppp="2.0"
            pk="1"
          />
        </div>
      </div>
    </>
  );
};

export default PowerRankings;
